module.exports = require("live/components/widget/widget-view");